// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2GjAn","selects":"Documents_selects__3hwkb"};